
export type ContractingFormType =
  | "customerData"
  | "customerType"
  | "paymentMethod"
  | "process"
  | "placeOfDelivery"
  | "product"
  | "overview"

export const ContractingFormType = {
  CustomerData: "customerData" as ContractingFormType,
  CustomerType: "customerType" as ContractingFormType,
  PaymentMethod: "paymentMethod" as ContractingFormType,
  Process: "process" as ContractingFormType,
  PlaceOfDelivery: "placeOfDelivery" as ContractingFormType,
  Product: "product" as ContractingFormType,
  Overview: "overview" as ContractingFormType
};